import React from 'react';
import styled from "styled-components";
import NumberInput from 'web/components/form-elements/NumberInput';
import DatePicker from 'web/components/form-elements/DatePicker';
import TimePickerInput from "web/components/form-elements/TimePickerInput";
import RadioButton from 'web/components/form-elements/RadioButton';
import TextInput from 'web/components/form-elements/TextInput';
import { Form, Formik, Field } from 'formik';
import { DateTimeWrapper1, Heading, To } from '../checkOutStyle';

const AltOptionsForm = ({ checkoutPageData, props, pageLanguageContents }) => {
    const altOfferDays = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY']

    const altQtyList = [
        { value: 'altqtyyes', label: 'Yes', },
        { value: 'altqtyno', label: 'No', },
    ]
    const altModeList = [
        { value: 'altmodeyes', label: 'Yes', },
        { value: 'altmodeno', label: 'No', },
    ]
    const altDateList = [
        { value: 'altdateyes', label: 'Yes', },
        { value: 'altdateno', label: 'No', },
    ]

    const poNumber = (type) => {
        return <div>
            <Heading>{pageLanguageContents?.BuyModal[13]?.PONumber}</Heading>
            <TextInput
                name='poNumber'
                placeholder={pageLanguageContents?.BuyModal[13]?.PONumber}
                maxLength='20'
                showErrorMessages={true}
                disabled={type === 'disabled' ? true : false}
            />
        </div>
    }

    return (
        <AltOptionWrapper>
            <div className="row">
                <div className="col-md-6">
                    <div className="mt-0">
                        <p>Alternate Quantity</p>
                    </div>
                    <div>
                        <RadioContainer>
                            {altQtyList?.map((data) => (
                                <Field
                                    component={RadioButton}
                                    name="invCheckoutIsAltQty"
                                    id={data.value}
                                    defaultValue={altQtyList[1].value}
                                    onSelect={e => { }}
                                    label={data.label}
                                />
                            ))}
                        </RadioContainer>
                    </div>
                    {/* Add input box for alternate QTY */}
                    {props.values?.invCheckoutIsAltQty === "altqtyyes" && <div>
                        <NumberInput
                            name="offerQty"
                            maxLength={4}
                            showErrorMessages={true}
                            decimalScale={0}
                            quantityLotsMaxValue={props.values?.maxOfferQty}
                        />
                    </div>}
                </div>
                <div className="col-md-6">
                    <div className="mt-0">
                        <p>Alternate Mode</p>
                    </div>
                    <div>
                        <RadioContainer>
                            {altModeList?.map((data) => (
                                <Field
                                    component={RadioButton}
                                    name="invCheckoutIsAltMode"
                                    id={data.value}
                                    defaultValue={altModeList[1].value}
                                    onSelect={e => {
                                        const { setFieldValue } = props
                                        if (e.target.value === 'altmodeyes') {
                                            if (checkoutPageData?.shippingMode === 'DELIVERY') {
                                                setFieldValue('curentShippingMode', 'PICKUP')
                                                setFieldValue('checkOutAltStartTimeBuyerOffer', checkoutPageData?.pickupOperationDetails?.operationsHourStart)
                                                setFieldValue('checkOutAltEndTimeBuyerOffer', checkoutPageData?.pickupOperationDetails?.operationsHourEnd)
                                            } else {
                                                setFieldValue('curentShippingMode', 'DELIVERY')
                                                setFieldValue('checkOutAltStartTimeBuyerOffer', checkoutPageData?.deliveryOperationDetails?.operationsHourStart)
                                                setFieldValue('checkOutAltEndTimeBuyerOffer', checkoutPageData?.deliveryOperationDetails?.operationsHourEnd)
                                            }
                                        } else {
                                            if (checkoutPageData?.shippingMode === 'DELIVERY') {
                                                setFieldValue('curentShippingMode', 'DELIVERY')
                                                setFieldValue('checkOutAltStartTimeBuyerOffer', checkoutPageData?.deliveryOperationDetails?.operationsHourStart)
                                                setFieldValue('checkOutAltEndTimeBuyerOffer', checkoutPageData?.deliveryOperationDetails?.operationsHourEnd)
                                            } else {
                                                setFieldValue('curentShippingMode', 'PICKUP')
                                                setFieldValue('checkOutAltStartTimeBuyerOffer', checkoutPageData?.pickupOperationDetails?.operationsHourStart)
                                                setFieldValue('checkOutAltEndTimeBuyerOffer', checkoutPageData?.pickupOperationDetails?.operationsHourEnd)
                                            }
                                        }
                                    }}
                                    label={data.label}
                                />
                            ))}
                        </RadioContainer>
                    </div>
                    {props.values?.invCheckoutIsAltMode === 'altmodeyes' &&
                        <div className="row">
                            <div className="col-12">
                                <RadioContainer>
                                    <Field
                                        component={RadioButton}
                                        name="altModeTransport"
                                        id={'altModeTransport'}
                                        defaultValue={'yes'}
                                        onSelect={(e) => { }}
                                        label={checkoutPageData?.shippingMode === 'DELIVERY' ? 'Pickup' : 'Delivery'}
                                        checked={true}
                                    />
                                </RadioContainer>
                            </div>
                        </div>}
                </div>
            </div>

            {/* as per latest client requirement date fields should be visible always, so radio is removed */}
            {/* and offer amount field is on the top, so removed from here */}
            {/* for now code is just commented */}

            {/* <div className='row'>
                <div className="col-md-6">
                    <div className="mt-0">
                        <p>Alternate Date</p>
                    </div>
                    <div>
                        <RadioContainer>
                            {altDateList?.map((data) => (
                                <Field
                                    component={RadioButton}
                                    id={data.value}
                                    name="invCheckoutIsAltDate"
                                    defaultValue={altDateList[1].value}
                                    onSelect={e => { }}
                                    label={data.label}
                                />
                            ))}
                        </RadioContainer>
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="mt-0">
                        <p>Alternative Offer<span className='star'>*</span> (p/pal)</p>
                    </div>
                    <div className='price-container'>
                        <NumberInput
                            name="offerAmount"
                            prefix={"$"}
                            placeholder="$ 0.00"
                            thousandSeparator={true}
                            maxLength={8}
                            decimalScale={2}
                            decimalSeparator=","
                            fixedDecimalScale
                            showErrorMessages={true}
                        />
                    </div>
                    {!checkoutPageData.displayCostToMarket &&
                        <div className="row align-items-center">
                            <div className="col-md-12 col-sm-12 target-price-column">
                                <p>Target Price : ${(parseInt(checkoutPageData.targetPrice)).toFixed(2)} (p/pal)</p>
                            </div>
                        </div>
                    }
                </div>
            </div> */}

            {props?.values?.invCheckoutIsAltDate === 'altdateyes' && <>
                <DateTimeWrapper1>
                    <DeliveryWindowSection>
                        <div>
                            {(props.values?.curentShippingMode === 'DELIVERY') ?
                                <Heading>{pageLanguageContents?.BuyModal[11]?.DeliveryDate}</Heading>
                                :
                                <Heading>{pageLanguageContents?.BuyModal[8]?.PickupDate}</Heading>
                            }
                            <DatePicker
                                name="checkOutAltDateBuyerOffer"
                                type="DatesDisabled"
                                minDate={props.values?.checkOutDateBuyerOfferMinDate}
                                selectedDate={props.values?.checkOutAltDateBuyerOffer}
                                nonDisabledDaysList={altOfferDays}
                            />
                        </div>
                        <div>
                            {(props.values?.curentShippingMode === 'DELIVERY') ?
                                <Heading>{pageLanguageContents?.BuyModal[12]?.DeliveryTime}</Heading>
                                :
                                <Heading>{pageLanguageContents?.BuyModal[9]?.PickupTime}</Heading>
                            }
                            <div className="d-flex align-items-center">
                                <TimePickerInput
                                    name="checkOutAltStartTimeBuyerOffer"
                                    type="time"
                                    selectedValue={props.values?.checkOutAltStartTimeBuyerOffer}
                                    showErrorMessages={true}
                                    props={props}
                                />
                                <To>
                                    {pageLanguageContents?.BuyModal[10]?.To}
                                </To>
                                <TimePickerInput
                                    name="checkOutAltEndTimeBuyerOffer"
                                    type="time"
                                    selectedValue={props.values?.checkOutAltEndTimeBuyerOffer}
                                    showErrorMessages={true}
                                    props={props}
                                />
                            </div>
                        </div>
                        <div>
                            {poNumber()}
                        </div>
                    </DeliveryWindowSection>
                </DateTimeWrapper1>
            </>}
        </AltOptionWrapper>
    )
};

export default AltOptionsForm;

const AltOptionWrapper = styled.div`
    .app-input-text{
        margin-bottom: 0px !important;
    }
`

const DeliveryWindowSection = styled.div`
    display: grid;
    grid-template-columns: 1fr 2fr 1fr;
    grid-gap: 0 30px;
    .file-input-wrapper .MuiFormControl-root{
        height: 37px;
    }
    .app-input-text{
        margin-bottom: 0px !important;
    }
    @media (max-width:500px) {
      grid-template-columns: 1fr;
    }
`;

const RadioContainer = styled.div`
    display: flex;
    grid-column-gap: 40px;
    grid-row-gap: 20px;
    align-items: center;
    label{
        text-align:initial;
    }
    @media(max-width:767px){
    /* flex-direction: column; */
    align-items: flex-start;
    }
`